import { DEFAULT_SEASON, isSeason, type Season } from './season';

/** The head script assigns a stable browser default before paint. SSR stays deterministic. */
export function resolveSiteSeason(accountTheme?: unknown): Season {
  if (isSeason(accountTheme)) return accountTheme;
  const assigned = typeof document === 'undefined' ? undefined : document.documentElement.dataset.defaultSeason;
  return assigned === 'alpine' || assigned === 'winter' ? assigned : DEFAULT_SEASON;
}
